import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Checkbox, DatePicker, Space, Row, Col, Avatar } from 'antd';
import dayjs from 'dayjs';
import { PhoneOutlined } from '@ant-design/icons';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL, DateTimeFormat, DateFormat } from '../Components/Constant';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import the Quill styles
import DynamicSelect from './DynamicSelectForLookup';
import { useSelector } from 'react-redux';
import { convertDateToUserTimezone,generateUTCDate,convertToDateJSON } from '../Components/Utility';
import CommentCard from '../ChatTextEditor/CommentCard';
import ChatEditor from '../ChatTextEditor/ChatEditor';

const { Option } = Select;
const { TextArea } = Input;

const FieldRendererEdit = ({ finalPicklistValues,setMapOfDateDateTimeFieldWithValue, mapOfDateDateTimeFieldWithValue, isFieldEditable, type, name, label, validationRules = [], form, picklist_values = [], handleSearch, lookupOptionforparent = {}, lookup_config = {}, setSelectedDate, handleAddressChange, fieldId, parentObjectName,setRichTextValues,richTextValues }) => {
    const [currency, setCurrency] = useState('');
    const defaultCurrency = useSelector(state => state.data.orgItem);

    const fetchOrgSetupDetails = async () => {

        setCurrency(defaultCurrency?.currency);

    };

    useEffect(() => {
        console.log('final picklist in edit mode',finalPicklistValues);
        fetchOrgSetupDetails();

    }, []);


    if (!isFieldEditable) return null;

   

    const initialValue = form.getFieldValue(name);
    switch (type) {
        case 'boolean':
            return (
                <Form.Item
                    name={name}
                    valuePropName="checked"
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <Checkbox></Checkbox>
                </Form.Item>
            );
        case 'integer':
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <Input initialValue={initialValue} placeholder={label} type="number" />
                </Form.Item>

            );
        case 'picklist':
            
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    // rules={validationRules}
                    noStyle
                    rules={[
                        ...(name === 'CurrencyIsoCode' ? [{ required: true, message: 'Currency is required' }] : []),
                        ...validationRules,
                        // ...isRequired
                      ]}
                
                >
                    <Select allowClear placeholder={label}>
                        {finalPicklistValues.map(option => (
                            <Option key={option} value={option}>
                                {option}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            );
        case 'multiselect':
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle

                >
                    <Select mode="multiple" placeholder={label}>
                        {picklist_values.map(option => (
                            <Option key={option} value={option}>
                                {option}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            );
        case 'lookup':
            return (
                <Form.Item
                    name={name}
                    label={label}
                    key={name}
                    initialValue={form.getFieldValue(name)}
                    rules={validationRules}
                    noStyle
                >
                    <DynamicSelect
                        objectName={parentObjectName}
                        lookupConfig={lookup_config}
                        onSearch={handleSearch}
                        value={form.getFieldValue(name)}
                        name={name}
                        lookupOptionforparent={lookupOptionforparent}
                        fieldId={fieldId}
                        onChange={(newValue) => form.setFieldsValue({ [name]: newValue })} // Update form value dynamically
                    />
                </Form.Item>
            );
        case 'date':
            return (
                <Form.Item
                    key={name}
                    name={name}
                    noStyle
                // label={renderLabel}
                // rules={isRequired}
                >
                    <Space>
                        <DatePicker
                            style={{ width: '100%' }}
                            format={DateFormat}
                            value={
                                form.getFieldValue(name)
                                    ? convertToDateJSON(form.getFieldValue(name),DateFormat)
                                    : null
                            }
                            onChange={(date, dateString) => {
                                console.log('date in on change',date,dateString);
                                setSelectedDate(date ? dayjs(dateString, DateFormat) : null);
                                form.setFieldsValue({ [name]: dateString});
                                setMapOfDateDateTimeFieldWithValue(prev => ({
                                    ...prev,
                                    [name]: dateString
                                }));
                            }}
                        />
                    </Space>
                </Form.Item>
            );

        case 'datetime':
            return (
                <Form.Item
                    key={name}
                    name={name}
                    noStyle
                // label={renderLabel}
                // rules={isRequired}
                >
                    <Space>
                        <DatePicker
                            showTime
                            style={{ width: '100%' }}
                            // disabled={isDisable}
                            format={DateTimeFormat}
                            value={
                                form.getFieldValue(name)
                                    ? convertToDateJSON(form.getFieldValue(name),DateTimeFormat)
                                    : null
                            }
                            onChange={(date, dateString) => {
                                setSelectedDate(date ? dayjs(dateString, DateTimeFormat) : null);
                                form.setFieldsValue({ [name]: dateString });
                                setMapOfDateDateTimeFieldWithValue(prev => ({
                                    ...prev,
                                    [name]: dateString
                                }));
                            }}
                        />
                    </Space>
                </Form.Item>
            );

        case 'address':
            return (
                <Form.Item
                    key={name}
                    initialValue={initialValue}
                    
                >
                    <Row gutter={16} style={{ marginBottom: '16px' }}>
                        <Col span={12}>
                            <Form.Item
                                name={[name, 'street']}
                                label="Street"
                                initialValue={initialValue?.street}
                            >
                                <Input placeholder="Street"

                                />
                            </Form.Item>

                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name={[name, 'city']}
                                label="City"
                                initialValue={initialValue?.city}

                            >
                                <Input placeholder="City"


                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16} style={{ marginBottom: '16px' }}> {/* Add margin-bottom for spacing between rows */}
                        <Col span={12}>
                            <Form.Item
                                name={[name, 'state']}
                                label="State"
                                initialValue={initialValue?.state}

                            >
                                <Input placeholder="State" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name={[name, 'postal_code']}
                                label="Postal Code"
                                initialValue={initialValue?.postal_code}
                            >
                                <Input placeholder="Postal Code"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16} style={{ marginBottom: '16px' }}>
                        <Col span={12}>
                            <Form.Item
                                name={[name, 'country']}
                                label="Country"
                                initialValue={initialValue?.country}

                            >
                                <Input placeholder="Country" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form.Item>

            );
        case 'textarea':
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <TextArea initialValue={initialValue} placeholder={label} autoSize />
                </Form.Item>
            );
        case 'currency':
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <Input initialValue={initialValue} placeholder={label} type="number"  />
                </Form.Item>
            );
        
        case 'richtext':
            return (
                <Form.Item
                    name={name}
                    label={label}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                     
                <ChatEditor 
                    onRichTextSaved={ (html)=>{
                        const content=  String(html || '');
                        form.setFieldsValue({ [name]: content });
                        setRichTextValues(prev=>({
                            ...prev,
                            [name]:content
                        }));
                        console.log(form.getFieldValue(name));
                    }}
                    showTools={true}
                    placeholder={"Write here..."}   
                    prefill={richTextValues[name] || ''}
                    editMode={true}
                    isRichTextField={true}
                />
                 
                    
                </Form.Item>
            );
        
        case 'percentage':
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <Input initialValue={initialValue} placeholder={label} type="number" addonAfter="%" />
                </Form.Item>
            );
        case 'phone':
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <Input initialValue={initialValue} placeholder={`Enter ${label}`} addonBefore={<PhoneOutlined />} />
                </Form.Item>
            );
        case 'email':
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <Input initialValue={initialValue} placeholder={label} type="email" />
                </Form.Item>
            );
        case 'url':
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <Input initialValue={initialValue} placeholder={label} type="url" />
                </Form.Item>
            );
        case 'image':
            return (
                <Form.Item
                    name={name}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <Input type="url" placeholder={`Enter ${label} URL`} />
                </Form.Item>
            );
        default:
            return (
                <Form.Item
                    name={name}
                    label={label}
                    initialValue={initialValue}
                    rules={validationRules}
                    noStyle
                >
                    <Input initialValue={initialValue} placeholder={label} />
                </Form.Item>
            );
    }
};

export default FieldRendererEdit;